'use client'

import { DocDropzone, useDropzoneContext } from '@repo/ui'
import { cn } from '@repo/ui/lib'

export const Dropzone = ({ className }: { className?: string }) => {
  const { addDocuments } = useDropzoneContext()

  return (
    <div
      className={cn('h-full w-full opacity-100 transition-all duration-300 ease-in-out', className)}
    >
      <DocDropzone onDrop={files => addDocuments(files)} />
    </div>
  )
}
